import { render } from "./AllocatedBackorderHistoryGrid.vue?vue&type=template&id=7ce11e00"
import script from "./AllocatedBackorderHistoryGrid.vue?vue&type=script&lang=js"
export * from "./AllocatedBackorderHistoryGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__